import {
  enableProdMode,
  Injector,
  importProvidersFrom,
  provideAppInitializer,
  inject,
  provideZoneChangeDetection,
} from '@angular/core';
import { environment } from './environments/environment';
import { BASE_PATH as BASE_PATH_ADMIN_API } from '@codegen/Vaimoo.Admin.API';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ApplicationInitializerFactory, HttpLoaderFactory } from './app/app-init';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
  HTTP_INTERCEPTORS,
  JsonpInterceptor,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { HttpResponseInterceptor } from '@core/interceptors/http-response.interceptor';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from './app/app.component';
import { providePrimeNG } from 'primeng/config';
import { CustomTheme } from './styles/custom_theme';
import { progressInterceptor, provideNgProgressHttp } from 'ngx-progressbar/http';
import { provideStore } from '@ngrx/store';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { HttpClient } from '@angular/common/http';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideStore(),
    provideHttpClient(withInterceptors([progressInterceptor])),
    provideNgProgressHttp({
      silentApis: [],
    }),
    importProvidersFrom(
      AppRoutingModule,
      BrowserModule,
      CoreModule,
      SharedModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.serviceWorker,
        registrationStrategy: 'registerImmediately',
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideAppInitializer(() => {
      const injector = inject(Injector);
      const translate = inject(TranslateService);
      return ApplicationInitializerFactory(injector, translate)();
    }),

    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { timezone: 'UTC', dateFormat: 'dd MMM yyyy HH:mm' },
    },
    {
      provide: BASE_PATH_ADMIN_API,
      useValue: environment.baseUrlAdminApi,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JsonpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpResponseInterceptor,
      multi: true,
    },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: CustomTheme,
        options: {
          // Kept in sync with ThemeService's DARK_CLASS.
          darkModeSelector: '.app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'primeng, primeui, tailwind-base, tailwind-utilities',
          },
        },
      },
    }),
  ],
}).catch((err) => console.log(err));
